import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ErrDialogData } from 'src/app/case-dashboard/interface/casehistory.interface';

@Component({
  selector: 'app-api-error-pop-up',
  templateUrl: './api-error-pop-up.component.html',
  styleUrls: ['./api-error-pop-up.component.scss']
})
export class ApiErrorPopUpComponent implements OnInit {
  errMsg: string;

  constructor(public dialogRef: MatDialogRef<ApiErrorPopUpComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ErrDialogData) { }

  ngOnInit(): void {
    this.errMsg = this.data.errMsg;
  }
  closeSession() {
    this.dialogRef.close();
  }
}
